import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import themeColors from '../../../assets/styles/themeColors';
import { variables } from '../../../assets/styles/variables';
import { formatMoneyNumeral } from '../../../util/helpers/numeralHelpers';
import { mediaBelow } from '../../../assets/styles/helper';

const Card = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  border: 1px solid ${themeColors.colorTextSecondary};
  border-radius: 4px;
  padding: 14px 16px;
  background: ${themeColors.colorBackgroundPrimary};
  ${mediaBelow(variables.breakpoints.bpMd)} {
    padding: 12px;
  }
`;

const LeftCol = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
`;

const RightCol = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;
  flex-shrink: 0;
  text-align: right;
`;

const Label = styled.div`
  font-family: ${variables.family.goldSilver}, sans-serif;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.4;
  color: ${themeColors.colorTextSecondary};
`;

const LockPrice = styled.div`
  font-family: ${variables.family.goldSilver}, sans-serif;
  font-size: 14px;
  font-weight: 700;
  line-height: 1.2;
  color: ${themeColors.colorTextPrimary};
`;

const LockPriceUnit = styled.span`
  font-weight: 500;
  color: ${themeColors.colorTextSecondary};
`;

const CardOnFile = styled.div`
  font-family: ${variables.family.goldSilver}, sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.2;
  color: ${themeColors.colorTextPrimary};
`;

const LearnMoreButton = styled.button`
  background: none;
  border: none;
  padding: 0;
  font-family: ${variables.family.goldSilver}, sans-serif;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.4;
  color: ${themeColors.colorPrimary};
  text-decoration: underline;
  cursor: pointer;
`;

const SellFromHomePriceGuaranteeCard = ({ price, onLearnMore }) => {
  const { t } = useTranslation();

  return (
    <Card data-cy="card-sfh-price-guarantee">
      <LeftCol>
        <Label>{t('sellWizard.sfhWizard.quantity.estLockPrice')}</Label>
        <LockPrice>
          {formatMoneyNumeral(price)}
          <LockPriceUnit>
            {t('sellWizard.sfhWizard.quantity.lockPerUnitSuffix')}
          </LockPriceUnit>
        </LockPrice>
      </LeftCol>
      <RightCol>
        <CardOnFile>{t('sellWizard.sfhWizard.quantity.preAuth')}</CardOnFile>
        <LearnMoreButton type="button" onClick={onLearnMore}>
          {t('sellWizard.sfhWizard.quantity.learnMore')}
        </LearnMoreButton>
      </RightCol>
    </Card>
  );
};

SellFromHomePriceGuaranteeCard.propTypes = {
  price: PropTypes.number,
  onLearnMore: PropTypes.func.isRequired,
};

export default SellFromHomePriceGuaranteeCard;
